import { Injectable } from '@angular/core';
import { PatientSearchResult } from '../../domain/models/patient-search-result.model';
import { PatientSearchResultDto } from '../dtos/party-search.dto';

@Injectable()
export class PatientSearchResultMapper {
  public toPatientSearchResult(dto: PatientSearchResultDto): PatientSearchResult {
    return {
      externalId: dto.ExternalId,
      name: dto.Name,
    };
  }
}
